import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";
import api from "@/lib/api";

/**
 * Contextual "view the policy" link for existing workflow screens.
 * Looks up the published policy mapped to a module key (incidents, safeguarding, journeys,
 * programmes, final, gps, attendance, assessments). Renders nothing if none is published yet.
 */
export default function PolicyLink({ module: moduleKey, testid }) {
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/policies/by-module/${moduleKey}`)
      .then((r) => { if (alive) setPolicy(r.data.policy); })
      .catch(() => {});
    return () => { alive = false; };
  }, [moduleKey]);

  if (!policy) return null;
  return (
    <Link
      to={`/policies/${policy.id}`}
      data-testid={testid || `policy-link-${moduleKey}`}
      className="inline-flex items-center gap-1.5 text-xs font-medium text-primary hover:underline"
    >
      <BookOpen className="h-3.5 w-3.5" /> View procedure: {policy.title} ({policy.reference})
    </Link>
  );
}
